import { enqueueSnackbar } from 'notistack';
export default (message, variant) => {
  enqueueSnackbar(message, { variant: variant, autoHideDuration: 5000 });
};
